import styled from 'styled-components'

const ProductName = styled.div`
  margin-bottom: 10px;

  ${props =>
    props.pdpV2 &&
    `
    margin: 8px 0;
    @media (min-width: ${props.theme.size.breakpoint['max-width'].sm}) {
      margin: 12px 0; 
    }
    `}

  sup {
    font-weight: ${props => props.theme.font.weight.bold};
  }

  span {
    margin-right: 5px;
  }
  h1 {
    font-size: 1.875rem;
    ${props =>
      props.pdpV2 &&
      `
        font-size: 16px;
        line-height: 1;
        margin-bottom: 0;

        @media (min-width: ${props.theme.size.breakpoint['max-width'].sm}) {
          font-size: 24px;
          line-height: inherit;
        }
    `}
  }
`

const Main = styled.h1`
  margin: 0;
  display: inline;
`

const CatNumber = styled.span`
  display: inline;
  font-weight: ${props => props.theme.font.weight.bold};
  font-size: 12px;
  color: ${props => props.theme.color.monochrome.dark};
  white-space: nowrap;
  @media (min-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    font-size: ${props => props.theme.font.size.base};
  }
`

export { ProductName, Main, CatNumber }
